import React from "react";
import {
  Container,
  Title,
  Text,
  Button,
  Grid,
  Card,
  Group,
  Badge,
  Box,
  List,
  ThemeIcon,
  rem,
  em,
} from "@mantine/core";
import {
  IconScissors,
  IconCalendarEvent,
  IconDeviceMobile,
  IconCreditCard,
  IconChartBar,
  IconBrandWhatsapp,
  IconBrandGoogle,
  IconRepeat,
  IconCheck,
  IconArrowRight,
  IconClock,
} from "@tabler/icons";
import METATAGSEO from "@/components/metaTagSEO";
import JsonLd from "@/components/JsonLd";
import { siteConfig } from "@/components/seoConfig";
import classes from "../styles/ArticlesCards.module.css";
import Image from "next/image";
import { useMediaQuery } from "@mantine/hooks";
export default function HaircutSalon() {
  const isMobile = useMediaQuery(`(max-width: ${em(750)})`);
  const seoData = {
    title: "אפליקציה לניהול תורים למספרות | תשלום מראש, אפס הברזות | QuickTor",
    description:
      "נמאס מביטולים ברגע האחרון? QuickTor מציעה אפליקציה לניהול תורים עם תשלום מראש, תזכורות ווטסאפ אוטומטיות ויומן חכם שיעלה את ההכנסות של המספרה שלך. התחל בחינם עכשיו!",
    canonicalUrl: `${siteConfig.baseUrl}/managing-queues-hair-salons`,
    OgImageUrl: "/barberCutHair.webp",
    altText:
      "מספרה גדולה עם ספרים ולקוחות וחתימה של הלוגו של אפליקציה לניהול תורים",
    keywords:
      "מערכת ניהול תורים, יומן חכם, ניהול תורים, זימון תורים, יומן פגישות, קוסמטיקאית, קוסמטיקאיות תוכנה לניהול יומן, אפליקציה לניהול תורים",
    isPartOf: "https://quicktor.co.il/",
  };

  const BreadcrumbListJson = [
    {
      "@type": "ListItem",
      item: `${siteConfig.baseUrl}/`,
      name: "דף הבית",
      position: 1,
    },
    {
      "@type": "ListItem",
      item: `${siteConfig.baseUrl}/managing-queues-hair-salons`,
      name: "ניהול תורים למספרות",
      position: 2,
    },
  ];
  return (
    <Box style={{ overflowX: "hidden", width: "100%", maxWidth: "100%" }}>
      {/* <Head>
        <title>ניהול תורים למספרות | פתרון מושלם לבעלי מספרות</title>
        <meta name="description" content="מערכת ניהול תורים מתקדמת במיוחד למספרות - נהל את העסק שלך בקלות, קבל תשלומים מראש ושלח תזכורות אוטומטיות" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link href="https://fonts.googleapis.com/css2?family=Heebo:wght@300;400;500;700;900&display=swap" rel="stylesheet" />
      </Head> */}

      <METATAGSEO {...seoData} />
      <JsonLd
        canonical="https://quicktor.co.il/managing-queues-hair-salons"
        title="אפליקציה לניהול תורים למספרות | תשלום מראש, אפס הברזות | QuickTor"
        description="מחפשת מערכת ניהול תורים לקוסמטיקאית? נהלי את התורים עם יומן חכם, קבלת תשלומים, תזכורות אוטומטיות, אישורי הגעה וקידום העסק בגוגל! - 14 יום ניסיון חינם ✓"
        OgImageUrl="/barberCutHair.webp"
        isPartOf={`https://quicktor.co.il/`}
        BreadcrumbListJson={BreadcrumbListJson}
      />

      {/* Hero Section */}
      <Box
        style={{
          backgroundImage:
            'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url("/barberCutHair.webp")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
          overflowX: "hidden",
          width: "100%",
          maxWidth: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <Container size="lg">
          <Box ta="center" py="xl">
            <Title
              className={classes.noto_sans_hebrew}
              fw={800}
              order={1}
              size={rem(60)}
              c="white"
              mb="md"
            >
              אפליקציה לניהול תורים למספרות
            </Title>
            <Text size="xl" c="gray.2" maw={600} mx="auto" mb="xl">
              פתרון מושלם שמותאם במיוחד לבעלי מספרות, עם כל הכלים שיעלו את הסלון
              שלך לרמה אחרת
            </Text>
            <Group justify="center" mt="xl">
              <Button
                variant="filled"
                color="blue"
                radius="xl"
                size="xl"
                leftSection={<IconCheck size={20} />}
              >
                התחל להשתמש - 14 יום חינם
              </Button>
              <Button
                component="a"
                href={`https://wa.me/972557259188?text=היי אני מעוניין להצטרף ל14 ימי ניסיון במערכת איך מתחילים?`}
                style={{ zIndex: 100 }}
                variant="outline"
                color="gray.2"
                radius="xl"
                size="xl"
              >
                לתיאום הדגמה אישית
              </Button>
            </Group>
          </Box>
        </Container>

        {/* Scissors icon as design element */}
        <ThemeIcon
          size={rem(100)}
          radius="xl"
          variant="light"
          color="amber"
          style={{
            position: "absolute",
            bottom: rem(40),
            left: rem(40),
            opacity: 0.8,
          }}
        >
          <IconScissors size={rem(60)} />
        </ThemeIcon>
      </Box>

      {/* Features Section */}
      <Box py={rem(100)} bg="white">
        <Container size="lg">
          <Title
            className={classes.noto_sans_hebrew}
            fw={600}
            order={2}
            ta="center"
            size={rem(42)}
            mb="xl"
          >
            למה המערכת שלנו{" "}
            <Text span c="amber" inherit>
              מושלמת למספרות
            </Text>
            ?
          </Title>
          <Text
            ta="center"
            c="dimmed"
            size="lg"
            maw={800}
            mx="auto"
            mb={rem(60)}
            className={classes.noto_sans_hebrew}
          >
            פיתחנו מערכת ייעודית שמבינה את האתגרים הייחודיים של ניהול מספרה
            מודרנית - מזימון תורים חכם ועד ניהול כספים וקידום העסק ברשת.
          </Text>

          <Grid>
            <Grid.Col span={{ base: 12, md: 4 }}>
              <Card shadow="sm" p="xl" radius="md" withBorder>
                <ThemeIcon
                  size="xl"
                  radius="md"
                  variant="light"
                  color="amber"
                  mb="md"
                >
                  <IconCalendarEvent size={rem(24)} />
                </ThemeIcon>
                <Title order={3} mb="sm">
                  יומן חכם
                </Title>
                <Text c="dimmed" mb="md">
                  יומן אינטואיטיבי המאפשר ניהול מספר ספרים במקביל, עם אפשרות
                  לתורים קבועים ללקוחות נאמנים. ממשק מעוצב מאפשר ניהול קל וגמיש
                  של זמני הטיפולים השונים.
                </Text>
                <Badge color="amber.2" variant="light">
                  אוטומציה חכמה
                </Badge>
              </Card>
            </Grid.Col>

            <Grid.Col span={{ base: 12, md: 4 }}>
              <Card shadow="sm" p="xl" radius="md" withBorder>
                <ThemeIcon
                  size="xl"
                  radius="md"
                  variant="light"
                  color="amber"
                  mb="md"
                >
                  <IconCreditCard size={rem(24)} />
                </ThemeIcon>
                <Title order={3} mb="sm">
                  תשלום מראש
                </Title>
                <Text c="dimmed" mb="md">
                  אמור די לביטולים ברגע האחרון! הגדר תשלום מראש כחובה לקביעת
                  תור, או שלח בקשות תשלום נוחות בווטסאפ. פתרון התשלומים שלנו
                  מאובטח ומתאים במיוחד למספרות.
                </Text>
                <Badge color="amber.2" variant="light">
                  מאובטח ומהיר
                </Badge>
              </Card>
            </Grid.Col>

            <Grid.Col span={{ base: 12, md: 4 }}>
              <Card shadow="sm" p="xl" radius="md" withBorder>
                <ThemeIcon
                  size="xl"
                  radius="md"
                  variant="light"
                  color="amber"
                  mb="md"
                >
                  <IconDeviceMobile size={rem(24)} />
                </ThemeIcon>
                <Title order={3} mb="sm">
                  תזכורות אוטומטיות
                </Title>
                <Text c="dimmed" mb="md">
                  תזכורות אוטומטיות בווטסאפ וSMS מבטיחות שהלקוחות שלך יגיעו
                  בזמן. אפשרות לאישור או ביטול תורים בלחיצת כפתור חוסכת זמן יקר
                  ומפנה תורים ריקים.
                </Text>
                <Badge color="amber.2" variant="light">
                  פחות ביטולים
                </Badge>
              </Card>
            </Grid.Col>
          </Grid>
        </Container>
      </Box>

      {/* Premium Styling Section - Diagonal */}
      <Box
        py={rem(120)}
        style={{
          background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
          clipPath: "polygon(0 0, 100% 5%, 100% 95%, 0 100%)",
          marginTop: rem(-20),
          marginBottom: rem(-20),
          position: "relative",
          zIndex: 1,
        }}
      >
        <Container size="lg">
          <Grid gutter={60} align="center">
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Title
                className={classes.noto_sans_hebrew}
                order={2}
                c="white"
                size={rem(38)}
                mb="xl"
                fw={700}
              >
                דף עסקי{" "}
                <Text span c="amber" inherit>
                  יוקרתי
                </Text>{" "}
                שמקודם בגוגל
              </Title>
              <Text c="gray.4" size="lg" mb="xl">
                המערכת שלנו מעניקה לך דף עסקי מקצועי שניתן לעצב ולמתג בהתאם
                לסגנון המספרה שלך. הדף ממוטב עבור מנועי חיפוש ומאפשר ללקוחות
                פוטנציאליים למצוא אותך בקלות.
              </Text>

              <List
                spacing="md"
                size="lg"
                center
                icon={
                  <ThemeIcon color="amber" size={28} radius="xl">
                    <IconCheck size={18} />
                  </ThemeIcon>
                }
              >
                <List.Item c="gray.2">
                  קבלת תשלומים על תורים למניעת ביטולים
                </List.Item>
                <List.Item c="gray.2">
                  עיצוב מותאם לסגנון הייחודי של המספרה שלך
                </List.Item>
                <List.Item c="gray.2">
                  קידום אורגני בגוגל ומנועי חיפוש
                </List.Item>
                <List.Item c="gray.2">
                  אפשרות להצגת גלריית עבודות ותמונות
                </List.Item>
                <List.Item c="gray.2">
                  התאמה מושלמת למובייל ולכל סוגי המכשירים
                </List.Item>
              </List>

              {/* <Button
                variant="filled"
                color="amber"
                radius="xl"
                mt="xl"
                rightSection={<IconArrowRight size={18} />}
              >
                צפה בדוגמאות לדפים עסקיים
              </Button> */}
              <Button
                component="a"
                target="_blank"
                href={`https://wa.me/972557259188?text=היי אני מעוניין להצטרף ל14 ימי ניסיון במערכת איך מתחילים?`}
                variant="filled"
                color="amber"
                radius="xl"
                mt="xl"
                rightSection={<IconArrowRight size={18} />}
              >
                קדימה דברו איתנו הגיע הזמן שעוד לקוחות יחשפו אליכם!
              </Button>
            </Grid.Col>

            <Grid.Col span={{ base: 12, md: 6 }}>
              <Box
                alt={
                  "ספר מקצועי המעניק תספורת מסוגננת ללקוח מרוצה במספרה מודרנית ומפנקת. הספר והלקוח שניהם מחייכים"
                }
                style={{
                  height: rem(500),
                  background: 'url("/hairsalon-with-phone.png")',
                  backgroundSize: "cover",
                  width: isMobile ? rem(555) : "100vh",
                  objectFit: "cover",
                  backgroundPosition: "center",
                  borderRadius: rem(16),
                  boxShadow: "0 30px 60px rgba(0,0,0,0.5)",
                  position: "relative",
                }}
              >
                <Box
                  style={{
                    position: "absolute",
                    top: rem(20),
                    right: rem(20),
                    background: "rgba(0,0,0,0.6)",
                    borderRadius: rem(8),
                    padding: rem(10),
                    display: "flex",
                    alignItems: "center",
                    gap: rem(10),
                  }}
                >
                  <ThemeIcon color="amber" size={rem(40)} radius="xl">
                    <IconBrandGoogle size={rem(24)} />
                  </ThemeIcon>
                  <Box>
                    <Text c="white" fw={500}>
                      דירוג גבוה
                    </Text>
                    <Text size="xs" c="gray.4">
                      קידום אורגני בגוגל
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Grid.Col>
          </Grid>
        </Container>
      </Box>

      {/* Smart Features */}
      <Box py={rem(100)} bg="#f9f9f9">
        <Container size="lg">
          <Title order={2} ta="center" size={rem(42)} mb={rem(20)}>
            פיצ׳רים{" "}
            <Text span c="amber" inherit>
              חכמים
            </Text>{" "}
            במיוחד
          </Title>
          <Text
            ta="center"
            c="dimmed"
            size="lg"
            maw={800}
            mx="auto"
            mb={rem(60)}
          >
            המערכת שלנו מציעה יכולות מתקדמות שתוכננו במיוחד לצרכים של מספרות
            וסלוני יופי מודרניים
          </Text>

          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Group mb="xl">
                <ThemeIcon size="xl" radius="md" variant="light" color="amber">
                  <IconRepeat size={rem(24)} />
                </ThemeIcon>
                <Box>
                  <Title order={3} mb="xs">
                    תורים קבועים אוטומטיים
                  </Title>
                  <Text c="dimmed">
                    המערכת קובעת באופן אוטומטי תורים קבועים ללקוחות קבועים במועד
                    שהוגדר להם. פתרון מושלם ללקוחות נאמנים שמגיעים על בסיס קבוע.
                  </Text>
                </Box>
              </Group>

              <Group mb="xl">
                <ThemeIcon size="xl" radius="md" variant="light" color="amber">
                  <IconBrandWhatsapp size={rem(24)} />
                </ThemeIcon>
                <Box>
                  <Title order={3} mb="xs">
                    תקשורת אוטומטית בווטסאפ
                  </Title>
                  <Text c="dimmed">
                    שליחת תזכורות, אישורי הגעה ובקשות תשלום ישירות לווטסאפ של
                    הלקוח. אין צורך בהתקנת אפליקציה נוספת - הכל מתנהל בפלטפורמה
                    המוכרת והנוחה.
                  </Text>
                </Box>
              </Group>

              <Group>
                <ThemeIcon size="xl" radius="md" variant="light" color="amber">
                  <IconChartBar size={rem(24)} />
                </ThemeIcon>
                <Box>
                  <Title order={3} mb="xs">
                    דו״חות וסטטיסטיקות
                  </Title>
                  <Text c="dimmed">
                    קבל תובנות מעמיקות על הביצועים של המספרה שלך. צפה בנתונים על
                    שעות עמוסות, טיפולים פופולריים, והכנסות, הכל בממשק ויזואלי
                    נוח וברור.
                  </Text>
                </Box>
              </Group>
            </Grid.Col>

            <Grid.Col span={{ base: 12, md: 6 }}>
              <Card
                shadow="sm"
                p={0}
                radius="lg"
                withBorder
                style={{ overflow: "hidden" }}
              >
                <Box
                  py="xl"
                  px="lg"
                  style={{
                    background: "linear-gradient(135deg, #111 0%, #333 100%)",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <Group>
                    <ThemeIcon color="amber" size="lg" radius="xl">
                      <IconClock size={rem(20)} />
                    </ThemeIcon>
                    <Text c="white" fw={700} size="lg">
                      היומן החכם שלך
                    </Text>
                  </Group>
                </Box>

                <Group grow p="xl" bg="white">
                  <Image
                    src="/section1.png"
                    alt="צילום מסך של מערכת ניהול יומן עם לוח זמנים ופגישות, לצד תזכורות וואטסאפ ללקוחות"
                    width={isMobile ? 300 : 400}
                    height={isMobile ? 300 : 400}
                    radius="md"
                  />
                </Group>

                {/* <Box p="lg" bg="white">
                  <Grid columns={7} mb="md">
                    {["א", "ב", "ג", "ד", "ה", "ו", "ש"].map((day, i) => (
                      <Grid.Col span={1} key={i}>
                        <Text
                          ta="center"
                          fw={i === 1 ? 700 : 400}
                          c={i === 1 ? "amber" : "inherit"}
                        >
                          {day}
                        </Text>
                      </Grid.Col>
                    ))}
                  </Grid>

                  <Grid columns={7} gutter="xs">
                    {Array(7)
                      .fill(0)
                      .map((_, weekIndex) =>
                        Array(7)
                          .fill(0)
                          .map((_, dayIndex) => {
                            const isToday = weekIndex === 0 && dayIndex === 1;
                            const hasAppointments =
                              (weekIndex === 0 &&
                                (dayIndex === 1 || dayIndex === 3)) ||
                              (weekIndex === 1 &&
                                (dayIndex === 0 || dayIndex === 4));

                            return (
                              <Grid.Col
                                span={1}
                                key={`${weekIndex}-${dayIndex}`}
                              >
                                <Box
                                  py="xs"
                                  style={{
                                    background: isToday
                                      ? "#fef3c7"
                                      : "transparent",
                                    border: isToday
                                      ? "2px solid #f59e0b"
                                      : "1px solid #e5e5e5",
                                    borderRadius: rem(8),
                                    height: rem(36),
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    position: "relative",
                                  }}
                                >
                                  <Text size="sm" fw={isToday ? 700 : 400}>
                                    {weekIndex * 7 + dayIndex + 1}
                                  </Text>

                                  {hasAppointments && (
                                    <Box
                                      style={{
                                        position: "absolute",
                                        bottom: rem(2),
                                        width: rem(4),
                                        height: rem(4),
                                        borderRadius: "50%",
                                        background: "#f59e0b",
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid.Col>
                            );
                          })
                      )}
                  </Grid>
                </Box> */}
              </Card>
            </Grid.Col>
          </Grid>
        </Container>
      </Box>

      {/* Call to Action */}
      <Box
        py={rem(80)}
        style={{
          background:
            "linear-gradient(to right,rgb(33, 151, 255),rgb(118, 185, 243))",
        }}
      >
        <Container size="md">
          <Box ta="center">
            <Title
              className={classes.noto_sans_hebrew}
              order={2}
              c="white"
              size={rem(42)}
              mb="lg"
            >
              מוכנים להעלות את המספרה שלכם{" "}
              <Text className={classes.noto_sans_hebrew} span fw={900} inherit>
                לרמה הבאה
              </Text>
              ?
            </Title>
            <Text c="white" size="xl" opacity={0.9} mb="xl" maw={700} mx="auto">
              הצטרפו למאות בעלי מספרות שכבר משתמשים במערכת שלנו וראו כיצד ניהול
              חכם של תורים יכול לשנות את העסק שלכם.
            </Text>
            <Group justify="center">
              <Button
                variant="white"
                color="dark"
                radius="xl"
                size="xl"
                leftSection={<IconScissors size={20} />}
              >
                לתקופת ניסיון - 14 יום חינם
              </Button>
            </Group>
            <Text c="white" opacity={0.8} size="sm" mt="md">
              ללא התחייבות. ניתן לבטל בכל עת.
            </Text>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
